// The key sessions arrive as the planner's session-type ids (the purpose's
// prefix, app/coach/head/graph.py proposal_body: "full_body", "long", …), the
// vocabulary of the week outline (head/prompts/week_outline.md). The card says
// them in words. Sport-free, since one id can be several sports' ("long" is a
// long run or a long ride). Mirror of mobile's lib/v2/proposal.ts.
export const KEY_SESSION_LABELS = {
  zone2: 'Zone 2', easy: 'Easy', long: 'Long session', endurance: 'Endurance', recovery: 'Recovery',
  tempo: 'Tempo', sweetspot: 'Sweet spot', threshold: 'Threshold', vo2max: 'VO2 max', interval: 'Intervals',
  intervals: 'Intervals', fartlek: 'Fartlek', technique: 'Technique', sprint: 'Sprint', mixed: 'Mixed',
  race_specific: 'Race-specific', opener: 'Opener',
  strength: 'Strength', power: 'Power', circuit: 'Circuit', core: 'Core', full_body: 'Full-body strength',
  upper_body: 'Upper-body strength', lower_body: 'Lower-body strength', mobility: 'Mobility',
  brick_easy: 'Easy brick', brick_tempo: 'Tempo brick', brick_race_specific: 'Race-specific brick',
};

/** A key-session id in words. An id the map doesn't know reads as itself, de-snaked; words pass through. */
export function keySessionLabel(id) {
  const raw = String(id ?? '').trim();
  const key = raw.toLowerCase();
  if (KEY_SESSION_LABELS[key]) return KEY_SESSION_LABELS[key];
  if (!/^[a-z0-9_-]+$/.test(raw)) return raw;            // already words ("Long ride")
  const words = key.replace(/[_-]+/g, ' ').trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : '';
}

/** body.key_sessions_by_phase as [phaseId, labels] pairs, empty phases dropped. */
export function keySessionsByPhase(body) {
  return Object.entries(body?.key_sessions_by_phase || {})
    .filter(([, list]) => Array.isArray(list) && list.length)
    .map(([pid, list]) => [pid, [...new Set(list.map(keySessionLabel).filter(Boolean))]]);
}
